import React, { Fragment } from 'react';
import { TextLink } from '@lightspeed/cirrus-text';
import ConnectedVendorReturnModal from './VendorReturnModal';

const VendorReturnEdit = ({
  vendorID,
  shopID,
  vendorReturnID,
  isOpen,
  isArchived,
  enabledFields = [],
  onOpenModal,
  onCloseModal,
}) => {
  const isDisabled = !~enabledFields.indexOf('shopID') || !~enabledFields.indexOf('vendorID');

  let warningMessage = '';
  if (isDisabled) {
    warningMessage = 'To update, the vendor return must be in open status';
    if (isArchived) {
      warningMessage += ' and not archived';
    }
  }

  return (
    <Fragment>
      <TextLink
        title="Edit vendor return"
        className="cr-ph-2 cr-pv-1"
        data-test="edit-vendor-return-open-link"
        onClick={onOpenModal}
      >
        Edit
      </TextLink>

      <ConnectedVendorReturnModal
        isEditMode
        isDisabled={isDisabled}
        warningMessage={warningMessage}
        isOpen={isOpen}
        handleCloseModal={onCloseModal}
        vendorReturnID={vendorReturnID}
        vendorID={vendorID}
        shopID={shopID}
      />
    </Fragment>
  );
};
export default VendorReturnEdit;
